module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    staticStyle: {
      "background-color": "#fff",
      "border-bottom": "0.5px solid #d2d6de"
    },
    attrs: {
      "to": "/"
    }
  }, [(_vm.myhost === 'hoodafinancehrm.com') ? _c('span', {
    staticClass: "logo-mini"
  }, [_c('img', {
    attrs: {
      "src": "https://hoodafinancehrm.com/hoodalogofavicon.png",
      "width": "40px"
    }
  })]) : _c('span', {
    staticClass: "logo-mini"
  }, [_c('img', {
    attrs: {
      "src": "https://demo.micromuneem.com/hdpi.png",
      "width": "40px"
    }
  })]), _vm._v(" "), (_vm.myhost === 'hoodafinancehrm.com') ? _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "https://hoodafinancehrm.com/hoodalogo.jpeg",
      "width": "200px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "logo-lg",
    attrs: {
      "else": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://demo.micromuneem.com/MicroMuneem-Logo.webp",
      "width": "200px"
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.$store.state.settingRecord.financial_session) ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": ""
    }
  }, [_c('strong', [_vm._v("Session : " + _vm._s(_vm.$store.state.settingRecord.financial_session.session))])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.type == 'admin' || _vm.currentUser.role_id == 5) ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": "daybook"
    }
  }, [_c('strong', [_vm._v("Day Book")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.type == 'admin') ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": "voucher"
    }
  }, [_c('strong', [_vm._v("Voucher Entries")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.type == 'admin') ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": "paymentvoucher"
    }
  }, [_c('strong', [_vm._v("Payment ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.type == 'admin') ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": "receiptvoucher"
    }
  }, [_c('strong', [_vm._v("Receipt ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.type == 'admin') ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": "contravoucher"
    }
  }, [_c('strong', [_vm._v("Contra ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.type == 'admin') ? _c('li', [_c('router-link', {
    staticClass: "btn btn-flat hidden-xs",
    attrs: {
      "to": "journalvoucher"
    }
  }, [_c('strong', [_vm._v("Journal ")])])], 1) : _vm._e(), _vm._v(" "), (this.$store.state.user.name) ? _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.photo,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.currentUser.name.toUpperCase()))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "background-color": "#ea4040"
    }
  }, [_c('img', {
    staticClass: "profile-user-img img-circle",
    attrs: {
      "src": _vm.photo,
      "alt": "User profile picture"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.currentUser.name.toUpperCase()) + " - " + _vm._s(_vm.currentUser.role.name) + "\n                "), _c('small', [_vm._v(_vm._s(_vm.currentUser.createdAt))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "to": "profile"
    }
  }, [_vm._v("Profile")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-danger btn-flat",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Sign out")])])])])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-lg btn-danger",
    staticStyle: {
      "color": "#fff",
      "background-color": "red"
    },
    attrs: {
      "title": "Logout User"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  })])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdbcbfa4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NaviBar.vue
// module id = 883
// module chunks = 0